import {useState} from "react";

export const useModalsReportTicketComparative = () => {
    const [visibleModalExportHtml, setVisibleModalExportHtml] = useState<boolean>(false);
    const [visibleModalInformationReport, setVisibleModalInformationReport] = useState<boolean>(false);
    const [textHeaderModalInformationReport, setTextHeaderModalInformationReport] = useState('');
    const [textInformationHeader, setTextInformationHeader] = useState('');
    const [textInformationBody, setTextInformationBody] = useState('');

    return {
        visibleModalExportHtml,
        setVisibleModalExportHtml,
        visibleModalInformationReport,
        setVisibleModalInformationReport,
        textHeaderModalInformationReport,
        setTextHeaderModalInformationReport,
        textInformationHeader,
        setTextInformationHeader,
        textInformationBody,
        setTextInformationBody,
    };
};
